import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Landing from './components/Landing'
import Dashboard from './components/dashboard';
import AIAgentManagerList from './components/ai_agent_manager_list';
import AIAgentManagerCreate from './components/ai_agent_manager_create';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import WorkflowTemplateRollbackHistory from './components/workflow_template_rollback_history';
import CustomerGuide from './components/customer_guide';
import FAQ from './components/faq';
import VersionInfo from './components/version_info';
import AuditLogViewer from './components/audit_log';
import ServiceDetails from './components/service_details';
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><><Header /><Dashboard /></></ProtectedRoute>} />
          <Route path="/ai-agents" element={<ProtectedRoute><><Header /><AIAgentManagerList /></></ProtectedRoute>} />
          <Route path="/ai-agents/create" element={<ProtectedRoute><><Header /><AIAgentManagerCreate /></></ProtectedRoute>} />
          <Route path="/workflow_template/rollback-history" element={<WorkflowTemplateRollbackHistory />} />
          <Route path="/guide" element={<CustomerGuide />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/versions" element={<VersionInfo />} />
          <Route path="/audit-log" element={<AuditLogViewer />} />
          <Route path="/service-detail/:slug" element={<ServiceDetails />} />
        </Routes>
        <ToastContainer position='top-right' autoClose={3000} />
      </Router>
    </AuthProvider>
  );
}

export default App;